import './Contact.css';
const Contact = () => {
  return (
    <section className="contact" id="contact">
      <div className="contact-container">
        <div className="contact-header">
          <span className="section-tag">Get In Touch</span>
          <h2 className="section-title">Ready to Find Your New Home?</h2>
          <p className="section-subtitle">
            Contact us today and let RoomBuddy handle everything for you.
          </p>
        </div>
        <div className="contact-grid">
          <a href="tel:+917989237393" className="contact-card contact-card-primary">
            <div className="contact-card-icon">📞</div>
            <h3 className="contact-card-title">Call Us</h3>
            <p className="contact-card-value">+91-7989237393</p>
            <span className="contact-card-action">Tap to call →</span>
          </a>
          <a href="mailto:support@roombuddy.in" className="contact-card">
            <div className="contact-card-icon">✉️</div>
            <h3 className="contact-card-title">Email Us</h3>
            <p className="contact-card-value">support@roombuddy.in</p>
            <span className="contact-card-action">Send email →</span>
          </a>
          <div className="contact-card">
            <div className="contact-card-icon">📍</div>
            <h3 className="contact-card-title">Visit Us</h3>
            <p className="contact-card-value">Madhapur, Hitech City</p>
            <span className="contact-card-sub">Hyderabad 500018</span>
          </div>
          <a href="https://play.google.com/store/apps/details?id=com.roombuddy.app" target="_blank" className="contact-card contact-card-app">
            <div className="contact-card-icon">📱</div>
            <h3 className="contact-card-title">Download App</h3>
            <p className="contact-card-value">Get it on Google Play</p>
            <span className="contact-card-action">Download →</span>
          </a>
        </div>
      </div>
    </section>
  );
};
export default Contact;